/* 08 LEFT - RUNWAY MUG LAUNCH AIRPORTS
   [ IATA, name ] for the custom mug builder (assets/mug-08l.js), in best seller order.
   = the top 150 of the 08left.com best sellers collection (pulled 2026-10-12) that have
   Route 08 runway geometry in runways-08l.js with two or more runways (Ryan: "150 big
   ones, multiple runways only"). Names come from route08-runway-diagrams/index.json.
   To add an airport: it must exist in runways-08l.js, then add a row here. */
window.__OL_MUG_AIRPORTS__ = [["ORD","Chicago O'Hare International Airport"],
["LAX","Los Angeles International Airport"],
["ATL","Hartsfield Jackson Atlanta International Airport"],
["DFW","Dallas Fort Worth International Airport"],
["JFK","John F. Kennedy International Airport"],
["BOS","Boston Logan International Airport"],
["SEA","Seattle–Tacoma International Airport"],
["SFO","San Francisco International Airport"],
["LHR","London Heathrow Airport"],
["MSP","Minneapolis–Saint Paul International Airport / Wold–Chamberlain Field"],
["DTW","Detroit Metropolitan Wayne County Airport"],
["DEN","Denver International Airport"],
["DCA","Ronald Reagan Washington National Airport"],
["IAD","Washington Dulles International Airport"],
["EWR","Newark Liberty International Airport"],
["PHX","Phoenix Sky Harbor International Airport"],
["LGA","LaGuardia Airport"],
["CDG","Charles de Gaulle International Airport"],
["MCO","Orlando International Airport"],
["PIT","Pittsburgh International Airport"],
["LAS","Harry Reid International Airport"],
["PHL","Philadelphia International Airport"],
["DAL","Dallas Love Field"],
["IAH","George Bush Intercontinental Airport"],
["AMS","Amsterdam Airport Schiphol"],
["PDX","Portland International Airport"],
["BNA","Nashville International Airport"],
["CLT","Charlotte Douglas International Airport"],
["SLC","Salt Lake City International Airport"],
["RDU","Raleigh-Durham International Airport"],
["MDW","Chicago Midway International Airport"],
["AUS","Austin Bergstrom International Airport"],
["MIA","Miami International Airport"],
["IND","Indianapolis International Airport"],
["MKE","General Mitchell International Airport"],
["MCI","Kansas City International Airport"],
["HNL","Daniel K. Inouye International Airport"],
["CVG","Cincinnati Northern Kentucky International Airport"],
["DAB","Daytona Beach International Airport"],
["CLE","Cleveland Hopkins International Airport"],
["TPA","Tampa International Airport"],
["GFK","Grand Forks International Airport"],
["FRA","Frankfurt Main Airport"],
["CMH","John Glenn Columbus International Airport"],
["YYZ","Toronto Pearson International Airport"],
["SNA","John Wayne Orange County International Airport"],
["STL","St. Louis Lambert International Airport"],
["MEM","Memphis International Airport"],
["FLL","Fort Lauderdale Hollywood International Airport"],
["BWI","Baltimore/Washington International Thurgood Marshall Airport"],
["SIN","Singapore Changi Airport"],
["SYD","Sydney Kingsford Smith International Airport"],
["NRT","Narita International Airport"],
["OAK","San Francisco Bay Oakland International Airport"],
["GRR","Gerald R. Ford International Airport"],
["ZRH","Zürich Airport"],
["HKG","Hong Kong International Airport"],
["GEG","Spokane International Airport"],
["SDF","Louisville Muhammad Ali International Airport"],
["ICT","Wichita Dwight D. Eisenhower National Airport"],
["HPN","Westchester County Airport"],
["OGG","Kahului International Airport"],
["BDL","Bradley International Airport"],
["LGB","Long Beach International Airport"],
["CHS","Charleston International Airport"],
["ANC","Ted Stevens Anchorage International Airport"],
["PSP","Palm Springs International Airport"],
["MUC","Munich Airport"],
["TUS","Tucson International Airport"],
["OMA","Eppley Airfield"],
["MAD","Adolfo Suárez Madrid–Barajas Airport"],
["BUF","Buffalo Niagara International Airport"],
["ABQ","Albuquerque International Sunport"],
["YVR","Vancouver International Airport"],
["RIC","Richmond International Airport"],
["KEF","Keflavik International Airport"],
["BCN","Josep Tarradellas Barcelona-El Prat Airport"],
["SJU","Luis Munoz Marin International Airport"],
["MSN","Dane County Regional Truax Field"],
["DUB","Dublin Airport"],
["ICN","Incheon International Airport"],
["ROC","Frederick Douglass Greater Rochester International Airport"],
["PVD","Rhode Island T. F. Green International Airport"],
["MSY","Louis Armstrong New Orleans International Airport"],
["HOU","William P. Hobby Airport"],
["BUR","Hollywood Burbank/Bob Hope Airport"],
["SAV","Savannah Hilton Head International Airport"],
["SJC","Norman Y. Mineta San Jose International Airport"],
["DSM","Des Moines International Airport"],
["PRG","Václav Havel Airport Prague"],
["SBA","Santa Barbara Municipal Airport"],
["PWM","Portland International Jetport"],
["ORF","Norfolk International Airport"],
["ONT","Ontario International Airport"],
["DXB","Dubai International Airport"],
["BZN","Bozeman Yellowstone International Airport"],
["CPH","Copenhagen Kastrup Airport"],
["RNO","Reno Tahoe International Airport"],
["PVG","Shanghai Pudong International Airport"],
["JAX","Jacksonville International Airport"],
["YUL","Montreal / Pierre Elliott Trudeau International Airport"],
["SRQ","Sarasota Bradenton International Airport"],
["SMF","Sacramento International Airport"],
["OKC","OKC Will Rogers World Airport"],
["TPE","Taiwan Taoyuan International Airport"],
["PIA","General Wayne A. Downing Peoria International Airport"],
["TLV","Ben Gurion International Airport"],
["TUL","Tulsa International Airport"],
["SYR","Syracuse Hancock International Airport"],
["SAT","San Antonio International Airport"],
["MLB","Melbourne Orlando International Airport"],
["MEL","Melbourne Airport"],
["BTV","Patrick Leahy Burlington International Airport"],
["BOI","Boise Air Terminal/Gowen Field"],
["BHM","Birmingham-Shuttlesworth International Airport"],
["ARN","Stockholm-Arlanda Airport"],
["YYC","Calgary International Airport"],
["RDM","Roberts Field"],
["BOM","Chhatrapati Shivaji Maharaj International Airport"],
["ALB","Albany International Airport"],
["TYS","McGhee Tyson Airport"],
["PEK","Beijing Capital International Airport"],
["SFB","Orlando Sanford International Airport"],
["FAR","Hector International Airport"],
["LEX","Blue Grass Airport"],
["FCO","Rome–Fiumicino Leonardo da Vinci International Airport"],
["SGN","Tan Son Nhat International Airport"],
["CAK","Akron Canton Regional Airport"],
["SBN","South Bend International Airport"],
["ILM","Wilmington International Airport"],
["MEX","Mexico City Benito Juárez International Airport"],
["GRB","Austin Straubel International Airport"],
["FSD","Sioux Falls Regional Airport"],
["EUG","Eugene Airport"],
["BUD","Budapest Liszt Ferenc International Airport"],
["ACK","Nantucket Memorial Airport"],
["HND","Tokyo Haneda International Airport"],
["CGN","Cologne Bonn Airport"],
["EZE","Ezeiza International Airport - Ministro Pistarini"],
["HSV","Huntsville International Airport"],
["TLH","Tallahassee International Airport"],
["PIE","St. Petersburg Clearwater International Airport"],
["MLI","Quad City International Airport"],
["ACY","Atlantic City International Airport"],
["BER","Berlin Brandenburg Airport"],
["ATH","Athens Eleftherios Venizelos International Airport"],
["COS","City of Colorado Springs Municipal Airport"],
["BKK","Suvarnabhumi Airport"],
["BOG","El Dorado International Airport"],
["ABE","Lehigh Valley International Airport"]];
